import { inject, Injectable } from "@angular/core";
import { PermissionApi } from "../Api/PermissionApi";
import { PermissionState } from "./PermissionState";
import { getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable({ providedIn: "root" })
export class PermissionEffects {
  private readonly permissionApi = inject(PermissionApi);
  private readonly permissionState = inject(PermissionState);

  async fetchPermissions(): Promise<void> {
    this.permissionState.setLoading(true);
    this.permissionState.setError(null);

    try {
      const permissions = await this.permissionApi.fetchPermissions();
      this.permissionState.setPermissions(permissions);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception, "An unknown error occurred while loading permissions.");
      this.permissionState.setError(errorMessage);
    } finally {
      this.permissionState.setLoading(false);
    }
  }
}
